/**
 * CapsuleGiftDashboardPage — host view for managing the Memory Capsule Gift.
 * Route: /dashboard/invitations/:invitationId/capsule-gift
 *
 * Fetches the invitation to get the birthday person's name, then renders
 * the CapsuleGiftManager panel within the standard dashboard chrome.
 */

import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { getDraft } from '@/src/infrastructure/lib/api';
import { CapsuleGiftManager } from './CapsuleGiftManager';

export function CapsuleGiftDashboardPage() {
  const { invitationId } = useParams<{ invitationId: string }>();
  const [birthdayName, setBirthdayName] = useState('');

  useEffect(() => {
    if (!invitationId) return;
    getDraft(invitationId)
      .then((inv) => {
        const bd = (inv as any)?.customData?.birthday;
        setBirthdayName(bd?.birthdayPersonName ?? '');
      })
      .catch(() => {});
  }, [invitationId]);

  if (!invitationId) return null;

  return (
    <div className="min-h-screen bg-[#060412] px-4 py-8 sm:px-8">
      <div className="max-w-xl mx-auto">
        {/* Back link */}
        <Link
          to="/dashboard/invitations"
          className="inline-flex items-center gap-1.5 text-white/40 text-sm hover:text-white/60 transition-colors mb-6"
        >
          <ChevronLeft size={15} />
          Back to Invitations
        </Link>

        <div className="mb-6">
          <h1 className="text-white text-2xl font-bold">Memory Capsule Gift</h1>
          <p className="text-white/40 text-sm mt-1">
            Convert your collected messages into a beautiful digital gift experience.
          </p>
        </div>

        <CapsuleGiftManager
          invitationId={invitationId}
          birthdayPersonName={birthdayName}
        />
      </div>
    </div>
  );
}
